import React from 'react';
import profile from '../asset/coverimg.png';
import shareIcon from '../asset/shareIcon.png';
import logoWhite from '../asset/logo.png';
import { Link, useLocation } from 'react-router-dom';

const Profile = ({ language }) => {
  const location = useLocation();
  const content = {
    ko: {
      title: '소녀 진',
      description: <>&nbsp;&nbsp;노동자 집안의 딸인 진이가 북한에서 공부잘하는 학생들만 다닐 수 있는 영재학교를 다니게 된다. 그 안에서 다양한 사회의 모습들을 경험하게 되며 진이가 각 회차마다 새롭게 깨닫게 되는 과정을 다룬다. <br/>&nbsp;&nbsp;더 넓은 사회에 대한 동경을 하는 진이가 펼쳐나가 게 될 이야기들을 담았다.</>,
      share: '공유',
      about: 'Uni Studio 소개',
      alertMessage: 'URL이 클립보드에 복사되었습니다.'
    },
    en: {
      title: 'Girl Jin',
      description: <>&nbsp;&nbsp; Jin, the daughter of a labor, will attend a gifted school in North Korea that only good students can attend. Through her experiences there, she encounters various aspects of society and learns new things with each encounter. <br/> &nbsp;&nbsp;The story follows Jin's growing admiration for the broader society as she unfolds her journey.</>,
      share: 'Share',
      about: 'About Uni Studio',
      alertMessage: 'URL has been copied to the clipboard.'
    }
  };

  const { title, description, share, about, alertMessage } = content[language];

  const handleShareClick = () => {
    const currentUrl = "http://uni-studio-web.s3-website.ap-northeast-2.amazonaws.com/";
    navigator.clipboard.writeText(currentUrl).then(() => {
      alert(alertMessage);
    }).catch(err => {
      console.error('Failed to copy URL: ', err);
    });
  };

  return (
    <>
    <div className="profile">
      <div className="profile-img-container">
        <img src={profile} alt="Profile" />
      </div>
      <div className="profile-info">
        <h2 className="profile-name">{title}</h2>
        <p className="profile-text">{description}</p>
      </div>
    </div>
    <div className="central-container">
      <div className="text-container">
        <p className="central-text">"We Are the Ones <br /> Who Open the Door to Unity"</p>
      </div>
      <div className="about-div">
        <Link to={`/about?lang=${language}`}>
          <button className="about">{about}</button>
        </Link>
      </div>
    </div>

    </>
  );
}

export default Profile;
